// Strict adapter for the candidate member-plans contract. No storage or network.
const obj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
const id = (v) => typeof v === "string" && /^[a-f0-9]{24}$/.test(v);
const str = (v, max) => typeof v === "string" && Array.from(v).length <= max;
const fail = () => { throw new Error("Unreadable member plan response"); };
export const PLAN_KEYS = ["meeting_point", "access", "return"];

export function planCapabilities(d) {
  if (!obj(d) || d.version !== 1 || d.max_recipients !== 1 || ["travel", "checklist", "sharing"].some((k) => typeof d[k] !== "boolean")) return fail();
  return { travel: d.travel, checklist: d.checklist, sharing: d.sharing };
}

export function planTravel(d) {
  if (!obj(d) || !Object.prototype.hasOwnProperty.call(d, "travel")) return fail();
  const t = d.travel;
  if (t === null) return null;
  if (!obj(t) || !str(t.meeting_point_public, 120) || !t.meeting_point_public.trim() ||
      typeof t.meet_time !== "string" || !/^([01]\d|2[0-3]):[0-5]\d$/.test(t.meet_time) || t.meet_time.length !== 5 ||
      !str(t.return_note, 300) || !Array.isArray(t.participants) || t.participants.length > 1 ||
      t.participants.some((p) => !obj(p) || !id(p.id) || !str(p.name, 200)) ||
      new Set(t.participants.map((p) => p.id)).size !== t.participants.length ||
      typeof t.updated_at !== "string" || !Number.isFinite(Date.parse(t.updated_at))) return fail();
  return { meeting_point_public: t.meeting_point_public, meet_time: t.meet_time, return_note: t.return_note,
    participants: t.participants.map((p) => ({ id: p.id, name: p.name })), updated_at: t.updated_at };
}

export function planChecklist(d) {
  const c = obj(d) && d.checklist;
  if (!obj(c) || !Array.isArray(c.items) || c.items.length !== 3 || typeof c.share_with_plan_members !== "boolean" ||
      c.items.some((i) => !obj(i) || !PLAN_KEYS.includes(i.key) || typeof i.done !== "boolean") ||
      new Set(c.items.map((i) => i.key)).size !== 3 ||
      (c.updated_at !== null && (typeof c.updated_at !== "string" || !Number.isFinite(Date.parse(c.updated_at))))) return fail();
  return { items: PLAN_KEYS.map((key) => ({ key, done: c.items.find((i) => i.key === key).done })),
    share_with_plan_members: c.share_with_plan_members, updated_at: c.updated_at };
}

export function matchingPlan(section, saved, payload) {
  if (section === "checklist") return saved.share_with_plan_members === payload.share_with_plan_members &&
    PLAN_KEYS.every((k) => saved.items.find((i) => i.key === k)?.done === payload.items.find((i) => i.key === k)?.done);
  return saved !== null && saved.meeting_point_public === payload.meeting_point_public.trim() && saved.meet_time === payload.meet_time &&
    saved.return_note === (payload.return_note || "").trim() &&
    JSON.stringify(saved.participants.map((p) => p.id).sort()) === JSON.stringify([...payload.participant_ids].sort());
}

export function sharedPlan(d) {
  const p = obj(d) && d.plan;
  if (!obj(p) || !id(p.activity_id) || !id(p.owner_id) || !str(p.owner_name, 200)) return fail();
  const travel = planTravel(p);
  if (travel === null) return fail();
  return { activityId: p.activity_id, ownerId: p.owner_id, ownerName: p.owner_name,
    title: typeof p.title === "string" ? p.title : typeof p.title?.de === "string" ? p.title.de : "Anreiseplan",
    travel, checklist: p.checklist === null ? null : planChecklist(p) };
}

export function sharedPlanList(d) {
  if (!obj(d) || !Array.isArray(d.plans) || d.plans.some((p) => !obj(p) || !id(p.activity_id) || !id(p.owner_id) || !str(p.owner_name, 200))) return fail();
  return d.plans.map((p) => ({ activityId: p.activity_id, ownerId: p.owner_id, ownerName: p.owner_name,
    title: typeof p.title === "string" ? p.title : typeof p.title?.de === "string" ? p.title.de : "Anreiseplan" }));
}
